import { createStore, combineReducers } from "redux";

// Reducers
import { manufacturingOrder, historical } from "./reducers";

//const client = new ApolloClient();

const reducers = combineReducers({
  manufacturingOrder,
  historical,
});

export default createStore(reducers);
